import * as React from 'react';
import { observer } from 'mobx-react';

import * as styles from './gift-description.less';
import { endRecurringForDisplayObject, frequencyLabelLowerCase, dateOfFirstGiftForDisplay } from '../../utils/recurring-utils';
import { PaymentLabel } from '../../webgiving-generated';
import { IWebGivingRecurringPaymentInfo } from '../../webgiving-payment-state';
import { Text } from '../../components/text';

export const GiftDescription = observer(({
	recurringInfo,
	currencyCode,
	amountFormatted,
	paymentLabel,
	fundName,
	tradingName,
	oneTimeGiftDateLabel,
	paymentDetailsText,
	numberOfGifts = null,
}: {
	recurringInfo: IWebGivingRecurringPaymentInfo | null,
	currencyCode: string,
	amountFormatted: string,
	paymentLabel: PaymentLabel,
	fundName: string,
	tradingName: string,
	oneTimeGiftDateLabel: string,
	paymentDetailsText?: string,
	numberOfGifts?: number | null,
}) => {
	if (paymentDetailsText) {
		return (
			<div className="brand-html-content" dangerouslySetInnerHTML={{ __html: paymentDetailsText }} />
		);
	}

	const fundLabel = fundName ? ` towards {{fundName}}` : '';

	if (recurringInfo) {
		const {frequency, startDate, endDate, endOccurrences, endType} = recurringInfo;
		const startDateFormatted = dateOfFirstGiftForDisplay(frequency, startDate);
		const endRecurring = endRecurringForDisplayObject(endType, endDate, endOccurrences, paymentLabel);
		const { text = '', params = {} } = endRecurring;

		return (
			<div>
				{/* tslint:disable:max-line-length */}
				<p><Text>Set up a recurring {paymentLabel.NounLowerCase} of</Text> <strong className={styles.currencyCode}>{currencyCode}</strong> <strong className={styles.amount}>{`$${amountFormatted}`}</strong><Text params={{tradingName, fundName}}>{`${fundLabel} for {{tradingName}}`}</Text></p>
				<p className={styles.recurringGiftLine}><b><Text params={{ startDate: startDateFormatted, ...params}}>{`Repeats ${frequencyLabelLowerCase(frequency)} `}</Text></b>
				<Text params={{ startDate: startDateFormatted, ...params}}>{`/ First ${paymentLabel.NounLowerCase} on {{startDate}} ${!!text ? `/ ${text}`: ''}`}</Text></p>
				{/* tslint:enable:max-line-length */}
			</div>
		);
	}

	let fundAndTradingName = <Text params={{ fundName, tradingName}}>{`${fundLabel} for {{tradingName}}.`}</Text>;

	if (numberOfGifts && numberOfGifts > 0) {
		fundAndTradingName = <Text params={{tradingName, numberOfGifts}}>{` towards {{numberOfGifts}} funds for {{tradingName}}.`}</Text>;
	}

	return (
		<div>
			{/* tslint:disable:max-line-length */}
			<p><Text>{`${paymentLabel.NounSentenceCase} of `}</Text><strong className={styles.currencyCode}>{currencyCode}</strong> <strong className={styles.amount}>${amountFormatted}</strong>{fundAndTradingName}</p>
			{oneTimeGiftDateLabel && <p className={styles.recurringGiftLine}><Text>When</Text>:<Text params={{ futureGiftLabel: oneTimeGiftDateLabel }}>{` {{futureGiftLabel}}`}</Text></p>}
			{/* tslint:enable:max-line-length */}
		</div>
	);
});
